<div class="appo-appointment-request-date">
  <form #appoAppointmentRequestDateForm="ngForm"
        id="{{formId}}"
        name="{{formId}}">
    <div class="container-fluid px-0">
      <div class="row">
        <div class="col-12 appo-appointment-request-date_text mb-1">
          <div>{{'SI_APPOINTMENT_DATA' | translate}}</div>
        </div>
        <div class="col-12">
          <si-appo-appointment-highlight [centerName]="model.center?.name || model.centerName"
                                         [professionalName]="model.professional?.name || model.professionalName"
                                         [serviceName]="model.service?.name || model.serviceName"
                                         [assistanceTypeCode]="model.teleconsultation.toString()"
                                         [reasonName]="model.appointmentReason[0]?.name"
                                         [collectiveName]="model.collective?.name"
          ></si-appo-appointment-highlight>
          <div class="pasi-line-lightgrey"></div>
        </div>
        <div class="col-12 col-lg-3">
          <si-datepicker id="appoFromDate"
                         name="appoFromDate"
                         text="SI_DATE_FROM"
                         placeholder="CORE_DATEPICKER_L"
                         [(model)]="model.fromDate"
                         (modelChange)="onChangeFromDateDatepicker()"
                         startOf="day"
                         [onlyFuture]="true"
                         [previousNextMode]="true"
                         [readonlyInput]="true"
                         rule="generic.fieldNotNull"
          ></si-datepicker>
        </div>
        <div class="col-12 col-lg-3 mb-2 appo-appointment-request-date_double-line">
          <div class="px-4 pl-lg-1 pr-lg-5">
            <si-selector id="appoTimePreference"
                         name="appoTimePreference"
                         placeholder="SI_SELECT_PLACEHOLDER"
                         [(model)]="model.timePreference"
                         (modelChange)="onChangeTimePreferenceSelector()"
                         path="/api/v1/timePreference?centerId={{model.center?.id}}"
                         [hideLabel]="true"
                         [showClear]="false"
                         [showDropdownSearch]="false"
                         [selectDefault]="true"
                         (selectDefaultChange)="selectDefaultLoaded($event, 'timePreference')"
                         rule="generic.fieldNotNull"
            ></si-selector>
          </div>
        </div>
        <div class="w-100"></div>
        <div class="col-12 col-lg-3 mt-3 ml-lg-4">
          <div class="appo-appointment-request-date_date mb-2">{{model.fromDate | amDateFormat: 'dddd, L' | titlecase}}</div>
          <div *ngIf="datesSameDayBool" class="pr-lg-5">
            <si-selector id="appoFromDateSlots"
                         name="appoFromDateSlots"
                         text="SI_HOUR_SELECT"
                         placeholder="SI_SELECT_PLACEHOLDER"
                         [(model)]="model.slotSelected"
                         (modelChange)="onChangeSlotSelected()"
                         (onShow)="onShowSlotsSelector()"
                         [values]="slotSelectorValues"
                         [showClear]="false"
                         rule="generic.fieldNotNull"
            ></si-selector>
          </div>
          <div *ngIf="!datesSameDayBool" class="appo-appointment-request-date_no-slots mr-lg-5">{{'SI_NO_AVAILABLE_DATES' | translate}}</div>
        </div>
        <div class="w-100"></div>
        <div *ngIf="!datesSameDayBool" class="col-12 col-lg-3 mt-3 ml-lg-4">
          <div class="appo-appointment-request-date_date mb-1">{{'SI_NEXT_AVAILABLE' | translate}} {{slotsList[0]?.startDate | amDateFormat: 'L'}}</div>
          <div class="pr-lg-5">
            <si-selector id="appoNextDateSlots"
                         name="appoNextDateSlots"
                         text="SI_HOUR_SELECT"
                         placeholder="SI_SELECT_PLACEHOLDER"
                         [(model)]="model.slotSelected"
                         (modelChange)="onChangeSlotSelected()"
                         (onShow)="onShowSlotsSelector()"
                         [values]="slotSelectorValues"
                         [showClear]="false"
                         rule="generic.fieldNotNull"
            ></si-selector>
          </div>
        </div>
        <ng-container *ngFor="let alert of appointmentScheduleAlerts">
          <div class="w-100"></div>
          <div class="col-12 col-lg-8 mt-3 ml-lg-4">
            <si-generic-alert [showAlert]="true"
                              [styleClass]="appointmentNoticeCategoriesClass[alert.category?.code]"
                              [text]="alert.description"
            ></si-generic-alert>
          </div>
        </ng-container>
        <div class="w-100"></div>
        <div class="col mt-4 ml-lg-4 mb-2 d-flex justify-content-center justify-content-lg-start">
          <button siPreventDoubleClick class="appo-appointment-request-date_next-date d-flex align-items-center"
                  (click)="getNextDaySlots()">
            <span>{{'SI_SHOW_NEXT_DAY_SLOTS' | translate}}</span>
            <i class="icosun-arrow_enter appo-appointment-past-list_icon ml-2"></i>
          </button>
        </div>
      </div>
    </div>
  </form>
  <ng-container *ngIf="displayNoAvailableDatesDialog">
    <si-appo-no-available-dates-dialog [(displayDialog)]="displayNoAvailableDatesDialog"
                                       [dialogText]="noAvailableDatesText"
                                       [showAppoRequestBackButton]="showAppoRequestBackButton"
                                       [showRequestAppointmentButton]="showRequestAppointmentButton"
                                       [model]="model"
                                       (updateChange)="onAcceptGoPreviousStep()"
    ></si-appo-no-available-dates-dialog>
  </ng-container>
  <ng-container *ngIf="displayTryAgainDatesDialog">
    <si-generic-dialog [(displayDialog)]="displayTryAgainDatesDialog"
                       dialogSizeClass="si-dialog-medium"
                       dialogTitle="SI_UPS"
                       dialogImg="assets/images/calendar.svg"
                       [dialogText]="tryAgainDatesText"
                       button1Text="SI_CLOSE"
                       button1Class="si-button_secondary"
    ></si-generic-dialog>
  </ng-container>
</div>
